import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  async getList (context) {
    const path = 'holidayset?populate=HolidayPeriods'
    let result = await Vue.axios.get(path)
      .then(response => {
        context.commit('SET_HOLIDAYSETLIST', response.data)
        return response.data
      })
    return result
  },
  addHolidayset (context, holidayset) {
    context.commit('ADD_HOLIDAYSET', holidayset)
  },
  async getHolidaySetData (context, params) {
    let path = 'holidayset/' + params.data.holidaysetId
    let requestParam

    // if (params.options && params.options.populate) {
    //   requestParam = { params: { populate: params.options.populate.join(',') } }
    // }

    let holidayset = await Vue.axios.get(path, requestParam)
      .then(response => {
        context.commit('UPDATE_HOLIDAYSET_IN_HOLIDAYSETLIST', response.data)
        return JSON.parse(JSON.stringify(response.data))
      })
    return holidayset
  },
  async createHolidaySetData (context, params) {
    delete params.data.id
    const response = await Vue.axios.post('holidayset', params.data)
      .then(response => {
        response = response.data
        context.commit('ADD_HOLIDAYSET', response)
        return response
      })
    return response
  },
  async deleteHolidaySet (context, params) {
    const response = await Vue.axios.delete(`holidayset/${params.id}`)
      .then(response => {
        return response.data
      })
    return response
  },
  async createHolidayPeriod (context, params) {
    if (!params.newHolidayPeriod.firstPlayDate || !params.newHolidayPeriod.lastPlayDate) return
    const response = await Vue.axios.post('holidayperiod', {
      HolidaySet: params.holidaySetId,
      firstPlayDate: Vue.prototype.$moment(params.newHolidayPeriod.firstPlayDate).format('YYYY-MM-DD HH:mm:ss'),
      lastPlayDate: Vue.prototype.$moment(params.newHolidayPeriod.lastPlayDate).format('YYYY-MM-DD HH:mm:ss')
    })
      .then(response => {
        return response.data
      })
    return response
  },
  async deleteHolidayPeriod (context, params) {
    const response = await Vue.axios.delete(`holidayperiod/${params.id}`)
      .then(response => {
        return response.data
      })
    return response
  },
  async updateHolidayPeriod (context, holidayperiod) {
    const response = await Vue.axios.patch(`holidayperiod/${holidayperiod.id}`, holidayperiod)
      .then(response => {
        return response.data
      })
    return response
  },
  async updateHolidaySetData (context, params) {
    const response = await Vue.axios.patch('holidayset/' + params.data.id, params.data)
      .then(response => {
        response = response.data
        context.commit('UPDATE_HOLIDAYSET_IN_HOLIDAYSETLIST', response)
        return response
      })
    return response
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/holidayset/holidayset.actions.js
// module id = null
// module chunks = 